import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import bannerImage from "../../Images/Banner/Gov-body.webp";

// Import all newspaper images
import media1 from "../../Images/media/media 1.webp";
import media2 from "../../Images/media/media 2.webp";
import media3 from "../../Images/media/media 3.webp";
import media4 from "../../Images/media/media 4.webp";
import media5 from "../../Images/media/media 5.webp";
import media6 from "../../Images/media/media 6.webp";
import media7 from "../../Images/media/media 7.webp";
import media8 from "../../Images/media/media 8.webp";
import media9 from "../../Images/media/media 9.webp";
import media10 from "../../Images/media/media 10.webp";
import media11 from "../../Images/media/media 11.webp";
import media12 from "../../Images/media/media 12.webp";
import media13 from "../../Images/media/media 13.webp";
import media14 from "../../Images/media/media 14.webp";
import media16 from "../../Images/media/media 16.webp";
import media15 from "../../Images/media/media 15.webp";
import media17 from "../../Images/media/media 17.webp";
import media18 from "../../Images/media/media 18.webp";
import media19 from "../../Images/media/media 19.webp";
import media20 from "../../Images/media/media 20.webp";
import media21 from "../../Images/media/media 21.webp";
import media22 from "../../Images/media/media 22.webp";
import media23 from "../../Images/media/media 23.webp";
import media24 from "../../Images/media/media 24.webp";
import media25 from "../../Images/media/media 25.webp";
import media26 from "../../Images/media/media 26.webp";
import media27 from "../../Images/media/media 27.webp";
import media28 from "../../Images/media/media 28.webp";
import media29 from "../../Images/media/media 29.webp";
import media30 from "../../Images/media/media 30.webp";
import media31 from "../../Images/media/media 31.webp";
import media33 from "../../Images/media/media 33.webp";
import media34 from "../../Images/media/media 34.webp";
import media35 from "../../Images/media/media 35.webp";
import media36 from "../../Images/media/media 36.webp";
import media37 from "../../Images/media/media 37.webp";
import media38 from "../../Images/media/media 38.webp";
import media39 from "../../Images/media/media 39.webp";
import media40 from "../../Images/media/media 40.webp";
import media41 from "../../Images/media/media 41.webp";
import media42 from "../../Images/media/media 42.webp";
import media43 from "../../Images/media/media 43.webp";
import media44 from "../../Images/events/Month-of-November-2025/WhatsApp Image 2025-11-13 at 2.07.31 PM.jpeg";
import media45 from "../../Images/events/Month-of-November-2025/WhatsApp Image 2025-11-14 at 5.04.10 PM.jpeg";
import media46 from "../../Images/events/Month-of-November-2025/WhatsApp Image 2025-11-15 at 6.24.18 AM.jpeg";
import media47 from "../../Images/events/Month-of-November-2025/WhatsApp Image 2025-11-15 at 6.46.25 AM.jpeg";
import media48 from "../../Images/events/Month-of-November-2025/WhatsApp Image 2025-11-17 at 7.24.41 AM.jpeg";
import media49 from "../../Images/events/Month-of-November-2025/WhatsApp Image 2025-11-16 at 7.08.07 AM.jpeg";
import media50 from "../../Images/events/Month-of-November-2025/WhatsApp Image 2025-11-16 at 7.14.22 AM.jpeg";
import media51 from "../../Images/events/Month-of-November-2025/WhatsApp Image 2025-11-17 at 7.24.42 AM.jpeg";
import media52 from "../../Images/events/Month-of-November-2025/WhatsApp Image 2025-11-17 at 10.03.09 AM.jpeg";
import media53 from "../../Images/media/WhatsApp Image 2025-11-19 at 9.54.46 AM.jpeg";
import media54 from "../../Images/media/WhatsApp Image 2025-11-18 at 11.58.31 AM.jpeg";
import media55 from "../../Images/media/WhatsApp Image 2025-11-18 at 11.58.30 AM.jpeg";
import media56 from "../../Images/media/WhatsApp Image 2025-11-18 at 11.58.30 AM (1).jpeg";
import media57 from "../../Images/media/media 44.jpg";
import media58 from "../../Images/media/media 45.jpg";
import media59 from "../../Images/media/media 46.jpg";
import media60 from "../../Images/media/media 47.jpg";
import media61 from "../../Images/media/media 48.jpg";
import media62 from "../../Images/media/media 49.jpg";
import media63 from "../../Images/media/media 50.jpg";
import media64 from "../../Images/media/media 52.jpg";
import media65 from "../../Images/media/media 53.jpg";
import media66 from "../../Images/media/media 54.webp";
import media67 from "../../Images/media/media 55.webp";
import media68 from "../../Images/media/media 56.webp";
import media69 from "../../Images/media/media 57.webp";
import media70 from "../../Images/media/media 58.webp";
import media71 from "../../Images/media/media 59.jpeg";
import media72 from "../../Images/media/media 60.jpeg";
import media73 from "../../Images/media/media 61.jpeg";
import media74 from "../../Images/media/media 62.webp";
import media75 from "../../Images/media/media 63.webp";
import media76 from "../../Images/media/media 64.webp";
import media77 from "../../Images/media/media 65.webp";
import media79 from "../../Images/media/media 67.jpeg";
import media80 from "../../Images/media/media 68.jpeg";
import media81 from "../../Images/media/media 69.jpeg";
import media82 from "../../Images/media/media 70.jpeg";
import media83 from "../../Images/media/media 71.jpeg";
import media84 from "../../Images/media/media 72.jpeg";
import media85 from "../../Images/media/media 73.jpeg";
import media86 from "../../Images/media/media 74.jpeg";
import media87 from "../../Images/media/media 75.jpeg";
import media88 from "../../Images/media/media 76.jpg";
import media89 from "../../Images/media/media 77.jpeg";
import media90 from "../../Images/media/media 78.png";

import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import '../../Placement.css';

const MediaCoverage = () => {
    const [activeTab, setActiveTab] = useState("media");
    const [selectedImage, setSelectedImage] = useState(null);

    const mediaVideos = [
        { id: 1, url: "https://www.youtube.com/embed/MWLWh0hgGa0", title: "Media Coverage of Futsal League" },
        { id: 2, url: "https://www.youtube.com/embed/VO2P-OGklh8", title: "Media Coverage of Glibs.in news" },
        { id: 3, url: "https://www.youtube.com/embed/qxvf9KPvKAw", title: "Media Coverage of Swaraj Express" },
        { id: 4, url: "https://www.youtube.com/embed/HqxxM7QkteM", title: "Media Coverage of Swaraj Express" },
        { id: 5, url: "https://www.youtube.com/embed/jgS_lbVI428", title: "Media Coverage of IBC24 News" },
        { id: 6, url: "https://www.youtube.com/embed/490Sw_wiZW8", title: "Media Coverage of Desh TV" },
        { id: 7, url: "https://www.youtube.com/embed/d-RIDjYSYFE", title: "Media Coverage of Swaraj Express" },
        { id: 8, url: "https://www.youtube.com/embed/d-H0D7OaRp0", title: "Media Coverage of Edumate TV" },
        { id: 9, url: "https://www.youtube.com/embed/msaIBvKXjws", title: "Media Coverage of IBC24" }
    ];

    const newspaperImages = [
        { id: 1, src: media1 },
        { id: 2, src: media2 },
        { id: 3, src: media3 },
        { id: 4, src: media4 },
        { id: 5, src: media5 },
        { id: 6, src: media6 },
        { id: 7, src: media7 },
        { id: 8, src: media8 },
        { id: 9, src: media9 },
        { id: 10, src: media10 },
        { id: 11, src: media11 },
        { id: 12, src: media12 },
        { id: 13, src: media13 },
        { id: 14, src: media14 },
        { id: 15, src: media15 },
        { id: 16, src: media16 },
        { id: 17, src: media17 },
        { id: 18, src: media18 },
        { id: 19, src: media19 },
        { id: 20, src: media20 },
        { id: 21, src: media21 },
        { id: 22, src: media22 },
        { id: 23, src: media23 },
        { id: 24, src: media24 },
        { id: 25, src: media25 },
        { id: 26, src: media26 },
        { id: 27, src: media27 },
        { id: 28, src: media28 },
        { id: 29, src: media29 },
        { id: 30, src: media30 },
        { id: 31, src: media31 },
        { id: 33, src: media33 },
        { id: 34, src: media34 },
        { id: 35, src: media35 },
        { id: 36, src: media36 },
        { id: 37, src: media37 },
        { id: 38, src: media38 },
        { id: 39, src: media39 },
        { id: 40, src: media40 },
        { id: 41, src: media41 },
        { id: 42, src: media42 },
        { id: 43, src: media43 },
        { id: 44, src: media44 },
        { id: 45, src: media45 },
        { id: 46, src: media46 },
        { id: 47, src: media47 },
        { id: 48, src: media48 },
        { id: 49, src: media49 },
        { id: 50, src: media50 },
        { id: 51, src: media51 },
        { id: 52, src: media52 },
        { id: 53, src: media53 },
        { id: 54, src: media54 },
        { id: 55, src: media55 },
        { id: 56, src: media56 },
        { id: 57, src: media57 },
        { id: 58, src: media58 },
        { id: 59, src: media59 },
        { id: 60, src: media60 },
        { id: 61, src: media61 },
        { id: 62, src: media62 },
        { id: 63, src: media63 },
        { id: 64, src: media64 },
        { id: 65, src: media65 },
        { id: 66, src: media66 },
        { id: 67, src: media67 },
        { id: 68, src: media68 },
        { id: 69, src: media69 },
        { id: 70, src: media70 },
        { id: 71, src: media71 },
        { id: 72, src: media72 },
        { id: 73, src: media73 },
        { id: 74, src: media74 },
        { id: 75, src: media75 },
        { id: 76, src: media76 },
        { id: 77, src: media77 },
        { id: 79, src: media79 },
        { id: 80, src: media80 },
        { id: 81, src: media81 },
        { id: 82, src: media82 },
        { id: 83, src: media83 },
        { id: 84, src: media84 },
        { id: 85, src: media85 },
        { id: 86, src: media86 },
        { id: 87, src: media87 },
        { id: 88, src: media88 },
        { id: 89, src: media89 },
        { id: 90, src: media90 },
    ].sort((a, b) => b.id - a.id);

    return (
        <>
            <title>ISBM University Media Coverage | News, Events & Achievements</title>
            <meta
                name="description"
                content="Discover ISBM University's media presence, featuring news highlights, achievements, and milestones shaping the future of education."
            />
            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="conatiner-xxl">
                        <div className="section-hero-content">
                            <h1>Media reflects and builds reputation</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                                        Home
                                    </a>
                                </li>
                                <li className="breadcrumb-item active text-white" aria-current="page">
                                    Media Coverage
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section className="media-section ptb-50">
                <div className="container-xxl">
                    <div className="row m-0">
                        <div className="row mb-5">
                            <div className="col-6">
                                <div className="media-tabs shadow-lg">
                                    <div
                                        className={`media-tab ${activeTab === 'media' ? 'active' : ''}`}
                                        onClick={() => setActiveTab('media')}
                                    >
                                        <div className="tab-icon">
                                            <i className="fa fa-video-camera" aria-hidden="true"></i>
                                        </div>
                                        <div className="tab-content">
                                            <h2>Media Coverage</h2>
                                            <p>Video news clips and interviews</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="media-tabs shadow-lg">
                                    <div
                                        className={`media-tab ${activeTab === 'newspaper' ? 'active' : ''}`}
                                        onClick={() => setActiveTab('newspaper')}
                                    >
                                        <div className="tab-icon">
                                            <i className="fa fa-newspaper-o" aria-hidden="true"></i>
                                        </div>
                                        <div className="tab-content">
                                            <h2>Newspaper Coverage</h2>
                                            <p>Articles and press coverage</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-12">
                            <div className="media-tab-content">
                                {activeTab === 'media' && (
                                    <div className="tab-pane active">
                                        <div className="media-card">
                                            <div className="tab-section-body">
                                                <div className="row m-0">
                                                    {mediaVideos.map((video) => (
                                                        <div className="pb-4 col-lg-3" key={video.id}>
                                                            <div className="card rounded-2 h-100 shadow-lg border-0">
                                                                <div className="ratio ratio-16x9 p-1">
                                                                    <iframe
                                                                        src={video.url}
                                                                        title={video.title}
                                                                        frameBorder="0"
                                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                                        allowFullScreen
                                                                    ></iframe>
                                                                </div>
                                                                <div className="card-body">
                                                                    <h6 className="card-title text-blue fw-bold text-center mb-0">
                                                                        {video.title}
                                                                    </h6>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {activeTab === 'newspaper' && (
                                    <div className="tab-pane active">
                                        <div className="media-card">
                                            <div className="tab-section-body">
                                                <div className="row m-0">
                                                    {newspaperImages.map((img) => (
                                                        <div className="pb-4 col-lg-3 mt-3" key={img.id}>
                                                            <img
                                                                src={img.src}
                                                                alt={`Newspaper ${img.id}`}
                                                                style={{
                                                                    width: "100%",
                                                                    height: "250px",
                                                                    objectFit: "cover",
                                                                    cursor: "pointer",
                                                                    border: "4px solid #001e62", // You can change the color/thickness here
                                                                    borderRadius: "8px", // Optional: adds rounded corners
                                                                }}
                                                                onClick={() => setSelectedImage(img.src)}
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Image Modal */}
            {selectedImage && (
                <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                    <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Newspaper Image</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setSelectedImage(null)}
                                ></button>
                            </div>
                            <div className="modal-body text-center">
                                <img
                                    src={selectedImage}
                                    alt="Enlarged newspaper"
                                    style={{
                                        maxWidth: "100%",
                                        height: "800px",
                                        border: "5px solid #001e62", // You can change the color/thickness here
                                        borderRadius: "8px", // Optional: adds rounded corners
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    {/* Modal Backdrop */}
                    <div
                        className="modal-backdrop fade show"
                        onClick={() => setSelectedImage(null)}
                    ></div>
                </div>
            )}

            <Footer />
        </>
    );
};

export default MediaCoverage;
